<svg-icon 
  src="assets/icons/bwm-question-circle.svg"
  class="fee-info-icon" 
  nz-tooltip 
  autoCloseOnScroll
  mobileExplainTooltipSheet
  [nzTooltipTitle]="tooltipContent" 
  [nzTooltipVisible]="tooltipVisible()"
  (nzTooltipVisibleChange)="onTooltipVisibleChange($event)" 
  (click)="onTooltipVisibleChange(!tooltipVisible())"
  nzTooltipOverlayClassName="basic" 
  [svgStyle]="{ 'height.px':16 }"
></svg-icon>
<ng-template #tooltipContent>
  <liberro-tooltip-content (closeClick)="onCloseTooltip($event)">
    <div tooltipHeader>
      <span>{{ 'investmentDetail.feeConfigs.feeTypes.' + feeType() | translate }}</span>
    </div>
    <div tooltipContent>
      {{ 'investmentDetail.feeConfigs.feeTypeTooltip.' + feeType() | translate }}
    </div>
  </liberro-tooltip-content>
</ng-template>